import { Component, OnInit } from "@angular/core";
import { AppConfig } from "../../../../configs/app";
import { AuthService } from "../../../../services/auth.service";
import { CommonService } from "../../../../services/common.service";
import { CartService } from "../../../../services/cart.service";
import { ReservationService } from "../../../../services/reservation.service";

@Component({
  selector: "page-cart-index",
  templateUrl: "./index.component.html",
})
export class PageCartIndexComponent implements OnInit {
  public $: any;
  public moment: any;
  public _: any;

  public dayLabel: any;

  public cartData: any = [];
  public serchData: any = [];
  public activeCartItemIndex = 0;

  public confirmBox = {
    disable: false,
    class: "btn wid-max btn-secondary is--lg",
  };

  public activatedStation: any = {};

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  constructor(
    public authService: AuthService,
    public commonService: CommonService,
    public appConfig: AppConfig,
    public cartService: CartService,
    public reservationService: ReservationService
  ) {
    this.$ = this.commonService.getJQuery();
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
    this.dayLabel = this.commonService.getDayLabel();
  }

  async ngOnInit() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* SET PAGE TITLE */
    this.commonService.setTitle(`カート | バスブックマーク`);

    this.cartData = await this.cartService.renewCartData();

    /* CHECK IF HAS DATA */
    if (this._.isEmpty(this.cartData)) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pagePlanList
      );
    }

    /* SHOW WARNING IF PRESENTS */
    this.warningChecks();

    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  warningChecks() {
    if (this.cartData.length === 2) {
      if (
        this.cartData[0].targetDay == this.cartData[1].targetDay &&
        this.cartData[0].plan.station_list[this.cartData[0].departure]
          .city_name ==
          this.cartData[1].plan.station_list[this.cartData[1].departure]
            .city_name &&
        this.cartData[0].plan.station_list[this.cartData[0].destination]
          .city_name ==
          this.cartData[1].plan.station_list[this.cartData[1].destination]
            .city_name
      ) {
        this.tempData.warningModal = {
          departureCity:
            this.cartData[0].plan.station_list[this.cartData[0].departure]
              .city_name,
          destinationCity:
            this.cartData[0].plan.station_list[this.cartData[0].destination]
              .city_name,
        };

        this.$("#warningModal").modal();
      }
    }
  }

  /* BELONGS TO CART */
  setRemovingItem(index: number) {
    this.activeCartItemIndex = index;
  }

  removeItem() {
    this.cartService.removeItem(this.activeCartItemIndex);
    /* RELOAD DATA */
    this.cartData = this.cartService.getCartData();
    this.serchData = this.cartService.getSerchData();

    if (this._.isEmpty(this.cartData)) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pagePlanList
      );
    }
  }
  /* END */

  confirmRegister() {
    if (this.confirmBox.disable == true) {
      this.confirmBox.disable = false;
      this.confirmBox.class = "btn wid-max btn-secondary is--lg";
    } else {
      this.confirmBox.disable = true;
      this.confirmBox.class = "btn wid-max btn-action is--lg";
    }
  }

  /* MAP */
  setActivatedStation(station: any = {}) {
    this.activatedStation = station;
  }

  async proceedBooking(type: any = null) {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* REMOVE OLD DATA */
    this.commonService.removeBatchData([
      this.appConfig.reservation.insuranceDataSessionName,
      this.appConfig.reservation.insuranceTokenSessionName,
      this.appConfig.reservation.passengerSessionName,
      this.appConfig.reservation.reservationCompleteDataSessionName,
      this.appConfig.reservation.reservationDataSessionName,
      this.appConfig.reservation.couponDataName,
    ]);

    await this.reservationService.createReservationData(type);

    /* HIDE LOGIN MODAL - WORKAROUND */
    this.$(".modal").modal("hide");
    this.$(".modal-backdrop").remove();
    this.$("body").removeClass("modal-open");

    /* REDIRECT TO NEXT PAGE */
    this.commonService.redirectToRoute(
      this.commonService.routePaths.pageReserveIndex
    );

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  /* FROM CHILDREN */
  loginFormCallback(returnData: any) {
    if (returnData.status == "success") {
      this.proceedBooking(
        returnData.type
          ? returnData.type
          : this.commonService.appConfig.reservation.registerWithBookingOff
      );
    }
  }

  footerMenuClick(data: any) {
    switch (data.event) {
      case "search":
        this.tempData.modalSearchInputEvent = {
          event: "openFilter",
          returnPlan: data.returnPlan ? data.returnPlan : false,
          nonce: new Date().getTime(),
        };
        break;
    }
  }
  /* END */

  inlineJS() {
    let $ = this.commonService.getJQuery();

    //fixフッターがある場合
    $(window).scroll(function () {
      if ($(".footer-fix").length) {
        let footerHight = $(".footer-fix").outerHeight();
        $(".main-container").css("padding-bottom", footerHight);
      }
    });
    /* END */
  }
}
